module.exports = __webpack_public_path__ + "static/index/img/baikal-503.35e93c88.jpg";